export default {
  path: 'new-project',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'New Project',
      component: () => import('@/views/menus/newProject/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
